/// <reference path="../../typings/.d.ts" />
export var WizardStatus;
(function (WizardStatus) {
    WizardStatus["New"] = "New";
    WizardStatus["Edit"] = "Edit";
    WizardStatus["None"] = "None";
})(WizardStatus || (WizardStatus = {}));
